import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { AiFillFilePdf } from "../../../assets/icons/vander";
import { useCalendarStore, useForm } from "../../../hooks";
import { toLocalISOString, filterObject } from "../../../helpers";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  CancelButton,
  MainButton,
  TertiaryButton,
} from "../../ui";
import { scheduleStatuses } from "../../data";
import { useFormMessages } from "../../hooks";
import {
  // ModalViewPatientScheduled,
  UploadInformedConsent,
  ModalInformedConsent,
  InformedConsent,
} from "../";
import { ScheduledPatientCard } from "../cards";

const initialFormData = {
  id: "",
  notes: "",
  start: "",
  end: "",
  title: "",
  state: "",
};

const initialFormValidations = {
  notes: [(value) => value.length > 0, "Las notas no pueden ser vacias"],
  start: [(value) => value.length > 0, "Selecciona una fecha inicial"],
  end: [(value) => value.length > 0, "Selecciona una fecha final"],
  title: [(value) => value.length > 0, "El titulo no puede ser vacio"],
  state: [(value) => value.length > 0, "Selecciona un estado"],
};

const initialScheduledPatient = {
  message: null,
  patientSurgeries: [],
};

export const ModalEditScheduleEvent = ({
  event,
  isOpen,
  setIsOpen,
  isProcedure,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    //Props
    message,
    isLoading,

    //Methods
    startUpdateByProcedure,
    startUpdateByAssessment,
    startGetPatientsByClearanceStaus,
  } = useCalendarStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [formValidations, setFormValidations] = useState(
    initialFormValidations
  );
  const [viewInformedConsent, setviewInformedConsent] = useState(null);
  const [isScheduledPatient, setIsScheduledPatient] = useState(
    initialScheduledPatient
  );

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onUpdateScheduleEvent = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      if (isProcedure) {
        startUpdateByProcedure(formState);
        return;
      }
      startUpdateByAssessment(formState);
      return;
    }
  };

  const onSchedulePatient = async () => {
    const response = await startGetPatientsByClearanceStaus();

    if (!Array.isArray(response)) {
      setIsScheduledPatient(() => ({
        message: {
          type: "error",
          text: response,
        },
        patientSurgeries: [],
      }));
      return;
    }

    setIsScheduledPatient(() => ({
      message: {
        type: "success",
      },
      patientSurgeries: response,
    }));

    setFormData(() => {
      const updated = {
        ...formState,
        patientSurgeryId: "",
        type: "PROCEDURE",
      };

      return updated;
    });

    setFormValidations(() => {
      const updated = {
        ...formValidations,
        patientSurgeryId: [
          (val) => (val ?? "").toString().trim().length > 0,
          "Selecciona un paciente",
        ],
      };

      return updated;
    });

    return;
  };

  const patientSurgeryIdChange = (event) => {
    const { name, value } = event.target;

    setFormData(() => {
      const updated = {
        ...formState,
        [name]: value,
        state: "BUSY",
      };

      return updated;
    });
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    // console.log("event", event);

    if (event && isOpen) {
      setFormData(() => ({
        id: event.id,
        notes: event.notes,
        start: toLocalISOString(event.start),
        end: toLocalISOString(event.end),
        title: event.title,
        state: event.state,
      }));
    }
  }, [event, isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setFormData(initialFormData);
      setFormValidations(initialFormValidations);
      setValidateForm(false);
      setFormSubmitted(false);
      setIsScheduledPatient(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (showSuccessMessage) {
      setIsOpen(false);
    }
  }, [showSuccessMessage]);

  // useEffect(() => {
  //   console.log("formState", formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log("formValidation", formValidation);
  // }, [formState]);

  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title" id="exampleModalLabel1">
          Editar evento
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          {event?.patientSurgeryId ? (
            <div className="col-md-12">
              <ScheduledPatientCard
                patientSurgery={event.patientSurgery}
                event={filterObject(event, [
                  "patientSurgeryId",
                  "patientSurgery",
                ])}
                isProcedure={isProcedure}
              />
            </div>
          ) : (
            isProcedure &&
            event?.schedule?.surgeryRoom?.name === "SEDACION" && (
              <div className="col-md-12">
                <div className="d-flex justify-content-between">
                  <h6>Paciente agendado:</h6>
                  <div className="d-grid gap-2">
                    <TertiaryButton
                      className={`fw-bold`}
                      type="button"
                      disabled={
                        isScheduledPatient.message?.type === "success" ||
                        isLoading
                      }
                      onClick={() => onSchedulePatient()}
                    >
                      Asignar paciente
                    </TertiaryButton>
                  </div>
                </div>
              </div>
            )
          )}

          {isScheduledPatient.message?.type === "error" && (
            <div className="col-md-12">
              <h6 className="mb-0">{isScheduledPatient.message.text}</h6>
            </div>
          )}

          {isScheduledPatient?.patientSurgeries?.length > 0 && (
            <div className="col-md-12">
              <SelectForm
                label={`Paciente`}
                options={isScheduledPatient.patientSurgeries}
                labelKey={"label"}
                validation={formValidation.patientSurgeryIdValid}
                submit={validateForm}
                name={`patientSurgeryId`}
                value={formState.patientSurgeryId}
                onInputChange={patientSurgeryIdChange}
              />
            </div>
          )}

          {/* Formulario estatico */}
          <>
            <div className="col-md-12">
              <InputForm
                label={"Titulo"}
                type={"text"}
                placeholder={"Titulo"}
                validation={formValidation.titleValid}
                submit={validateForm}
                name={"title"}
                value={formState.title}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Link de conexión / Ubicación"}
                type={"text"}
                placeholder={"Link de conexión / Ubicación"}
                validation={formValidation.notesValid}
                submit={validateForm}
                name={"notes"}
                value={formState.notes}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <SelectForm
                label={`Estado`}
                options={scheduleStatuses}
                labelKey={"name"}
                validation={formValidation.stateValid}
                submit={validateForm}
                name={`state`}
                value={formState.state}
                onInputChange={onInputChange}
                disabled={formState?.patientSurgeryId}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Fecha y hora de inicio"}
                type={"datetime-local"}
                validation={formValidation.startValid}
                submit={validateForm}
                name={"start"}
                value={formState.start}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Fecha y hora de fin"}
                type={"datetime-local"}
                validation={formValidation.endValid}
                submit={validateForm}
                name={"end"}
                value={formState.end}
                onInputChange={onInputChange}
              />
            </div>
          </>

          {/* Paciente agendado */}
          <>
            {event?.patientSurgeryId && (
              <>
                {isProcedure && (
                  <div className="col-md-12">
                    <label className="form-label mb-0">
                      Consentimiento informado
                    </label>

                    {event.eventFiles.length > 0 ? (
                      <InformedConsent eventFiles={event.eventFiles} />
                    ) : (
                      <UploadInformedConsent scheduleEventId={event.id} />
                    )}
                  </div>
                )}
              </>
            )}
          </>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>
        </div>
      </Modal.Body>
      {event && (
        <>
          {!event.isPastEvent && (
            <Modal.Footer>
              <CancelButton
                type={"button"}
                onClick={() => setIsOpen(false)}
                disabled={isLoading}
              >
                Cancelar
              </CancelButton>
              <MainButton
                type={"button"}
                onClick={() => onUpdateScheduleEvent()}
                disabled={isLoading}
              >
                Guardar cambios
              </MainButton>
            </Modal.Footer>
          )}
        </>
      )}
    </Modal>
  );
};
